module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-gallery",
    staticStyle: {
      "display": "block"
    }
  }, [_c('span', {
    staticClass: "weui-gallery__img",
    style: (_vm.styleObject),
    on: {
      "click": _vm.clickLayer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-gallery__opr"
  }, [_c('a', {
    staticClass: "weui-gallery__del",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.deleteThis
    }
  }, [_c('i', {
    staticClass: "weui-icon-delete weui-icon_gallery-delete"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-53629528!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/gallary/gallary.vue
// module id = 241
// module chunks = 0